import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { ProjectManagerGoodsInTable } from "src/helpers/Tables/projectManagerGoodsInTable";
import IconDownload from "src/assets/images/icon_download.svg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
import _ from "lodash";
import { toast } from "react-toastify";
import { GetError } from "src/constant";
import Pagination from "@mui/material/Pagination";
import { getAllGoodsInData, getAllGoodsInData1 } from "src/thunks/goodsin";

const ProjectManagerGoodsInList = () => {
  const dispatch = useDispatch();
  const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
  const { allGoodInData } = useSelector((state) => state.goodsin);
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 1000;
  const filteredLength = _.filter(
    allGoodInData || [],
    (d) => d.statusValue !== "Review"
  ).length;

  const { filterAllData } = useSelector((state) => state.goodsin);
  const filterData = filterAllData["goodsIn"];

  useEffect(() => {
    getGoodsInDataFunc(currentPage);
  }, [currentPage]);

  const getGoodsInDataFunc = async (page) => {
    try {
      let data = {
        isDateRange: false,
        from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
        DepotIds: [filterData?.depotId?.id || 0],
        ClientIds: [userDetails?.projects[0]?.clientId || 0],
        ProjectIds: [filterData?.projectId?.id || 0],
        currentPage: page,
      };

      if (filterData?.toDate) {
        data["isDateRange"] = true;
        data["to"] = moment(filterData?.toDate).format("YYYY-MM-DD");
      }

      await dispatch(getAllGoodsInData1({ ...data })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const saveExcelFile = (
    tableData,
    dateFromStr,
    dateToStr,
    clientStr,
    projectStr
  ) => {
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Date:", `${moment(dateFromStr).format("DD-MMM-YYYY")}  ${dateToStr ? "To  " + moment(dateToStr).format("DD-MMM-YYYY") : ""}`],
      ["Client:", clientStr || "All Client"],
      ["Project:", projectStr?.name || "All Project"],
      [],
      [],
      [
        "IN TIME",
        "REF NUMBER",
        "PROJECT",
        "DEPOT",
        "ITEMS",
        "DMG",
        "INTERNAL",
        "EXTERNAL",
        "STATUS",
      ],
      ...tableData.map((row) => {
        return [
          moment(row?.inTime).format("DD-MMM-YYYY, HH:mm"),
          row?.referenceNumber,
          row?.projectName,
          row?.depotCode,
          row?.itemCount || 0,
          row?.damagedCount || 0,
          row?.interiorSpace || 0,
          row?.exteriorSpace || 0,
          row.statusValue,
        ];
      }),
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // Generate the Excel file buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Convert buffer to Blob and save the file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const customFileName = `GoodsIn Data ${moment().format(
      "DD:MMM:YYYY:HH:mm"
    )}.xlsx`;
    saveAs(data, customFileName);
  };

  const Print = () => {
    const client = userDetails?.projects[0]?.clientName;
    const project = filterData?.projectId;
    let filteredArray = _.filter(allGoodInData || [], (d) => d.statusValue !== "Review")

    saveExcelFile(
      filteredArray,
      filterData?.fromDate,
      filterData?.toDate,
      client,
      project
    );
  };

  const handleChange = (event, value) => {
    setCurrentPage(value); // Update the page when the user clicks on a pagination button
  };

  return (
    <>
      <div
        className={`${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true
          ? "add-overlay-for-depot-dropdown"
          : ""
          } main-goods-in-tab-div d-flex flex-column ms-3 me-3`}
      >
        <ProjectManagerGoodsInTable allGoodsInTableData={allGoodInData} />
        <div
          style={{ height: 60 }}
          className="d-flex flex-row justify-content-between align-items-center"
        >
          <div className="d-flex">
            {filteredLength.length > 0 && (
              <Pagination
                count={Math.ceil(filteredLength / pageSize)}
                page={currentPage}
                onChange={handleChange}
                variant="outlined"
                color="primary"
              />
            )}
          </div>
          <div className="d-flex">
            <Button
              disabled={allGoodInData?.length <= 0 ? true : false}
              variant="outlined"
              className={`save-report-btn-style ms-2 ${allGoodInData?.length <= 0 ? "fade-out" : ""
                }`}
              startIcon={
                <img src={IconDownload} width={17} height={17} alt="new"></img>
              }
              type="submit"
              onClick={() => Print()}
            >
              Save Report
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProjectManagerGoodsInList;
